<div (click)="onClick()" (keydown)="onKeyDown($event)" tabindex="0" [class]="containerClasses">
    @if (multiple) {
    <input type="checkbox" [checked]="selected" class="mr-2 pointer-events-none" tabindex="-1" sag-ui-checkbox />
    }
    <span [class]="textClasses" #text>
        <ng-content></ng-content>
    </span>
</div>
